
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.5 0H5C3.67436 0.00144754 2.40343 0.528697 1.46607 1.46607C0.528697 2.40343 0.00144754 3.67436 0 5V27.5C0.00144754 28.8256 0.528697 30.0966 1.46607 31.0339C2.40343 31.9713 3.67436 32.4986 5 32.5H27.5C28.8256 32.4986 30.0966 31.9713 31.0339 31.0339C31.9713 30.0966 32.4986 28.8256 32.5 27.5V5C32.4986 3.67436 31.9713 2.40343 31.0339 1.46607C30.0966 0.528697 28.8256 0.00144754 27.5 0ZM24.707 10.8039L14.207 23.3039C14.0919 23.4411 13.9485 23.5519 13.7868 23.6289C13.625 23.7059 13.4486 23.7472 13.2695 23.75H13.2484C13.0732 23.7499 12.9 23.713 12.74 23.6417C12.5799 23.5704 12.4367 23.4662 12.3195 23.3359L7.81953 18.3359C7.70525 18.2147 7.61635 18.0719 7.55805 17.9158C7.49976 17.7598 7.47325 17.5936 7.48008 17.4272C7.48692 17.2607 7.52695 17.0973 7.59784 16.9465C7.66873 16.7958 7.76903 16.6607 7.89287 16.5493C8.0167 16.4378 8.16156 16.3523 8.31894 16.2976C8.47631 16.243 8.64302 16.2203 8.80927 16.231C8.97552 16.2417 9.13796 16.2855 9.28703 16.3599C9.4361 16.4343 9.56881 16.5377 9.67734 16.6641L13.2156 20.5953L22.793 9.19609C23.0078 8.94772 23.3117 8.79386 23.6391 8.76777C23.9665 8.74169 24.2909 8.84547 24.5424 9.05669C24.7938 9.26791 24.9521 9.5696 24.9829 9.89655C25.0137 10.2235 24.9146 10.5494 24.707 10.8039Z","fill":"currentColor"}})])
          )
        }
      }
    